module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('ul', {
    staticClass: "quickMenu",
    class: {
      'quickMenu-direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('li', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/trading-account/list'
    }
  }, [_c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('account_list').tCapitalizeFirstLetter()))]), _vm._v(" "), _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/account-list.svg")
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/deposit'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/deposit.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('deposit').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/withdraw'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/withdraw.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('withdraw').tTitle()))])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/internal-transfer'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/internal-transfer.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('internal_transfer').tCapitalizeFirstLetter()))])])], 1), _vm._v(" "), (!_vm.IsDemo && _vm.IsVerified) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/trading-account/create-live'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/live-account.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('open_live_account').tCapitalizeFirstLetter()))])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/trading-account/create-demo'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/demo-account.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('open_demo_account').tCapitalizeFirstLetter()))])])], 1), _vm._v(" "), (_vm.IsLive || _vm.isIB) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/profile/upload-documents'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/upload.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('upload_documents').tCapitalizeFirstLetter()))])])], 1) : _vm._e(), _vm._v(" "), (_vm.IsLive && _vm.BonusConfig.depositBonus.enabled) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance/my-bonuses'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/bonus.svg")
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('my_bonuses').tCapitalizeFirstLetter()))])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/profile/personal'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/profile.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('my_profile').tCapitalizeFirstLetter()))])])], 1), _vm._v(" "), (_vm.isIB) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/partner/overview'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/partners.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('partners').tTitle()))])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/trading-account/download'
    }
  }, [_c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/download.svg")
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'is-size-6': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('download').tTitle()))])])], 1), _vm._v(" "), _c('li', [(_vm.Language == 'it') ? _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/it/learn/video-coursi",
      "target": "_blank"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])]) : (_vm.Language == 'es') ? _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/es/learn/cursos-videos",
      "target": "_blank"
    }
  }, [_vm._m(1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])]) : (_vm.Language == 'pt') ? _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/pt/learn/video-courses",
      "target": "_blank"
    }
  }, [_vm._m(2), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])]) : (_vm.Language == 'ms') ? _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/ms/learn/video-courses",
      "target": "_blank"
    }
  }, [_vm._m(3), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])]) : (_vm.Language == 'id') ? _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/id/learn/video-courses",
      "target": "_blank"
    }
  }, [_vm._m(4), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])]) : _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/learn/video-courses/",
      "target": "_blank"
    }
  }, [_vm._m(5), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('video_courses')))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.Language != 'zh' && _vm.Language != 'ar' ? 'https://www.eurotrader.com/' + _vm.Language + '/learn/ebooks' : 'https://www.eurotrader.com/learn/ebooks',
      "target": "_blank"
    }
  }, [_vm._m(6), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('ebooks')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/video-courses.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/quick-menu/ebooks.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de58c12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/QuickMenu.vue
// module id = 715
// module chunks = 0